export default __webpack_public_path__ + "static/logo11-32c169542fcdf0fb22d005bb776fc82f.webp";